import Admin from './admin/App';
import './globals.css'

const App = () => (<Admin />)

export default App;
